export const materials = [
	{
		id: 0,
		name: 'Oro',
		value: 'oro'
	},
	{
		id: 1,
		name: 'Plata 925',
		value: 'plata_925'
	},
	{
		id: 2,
		name: 'Plata 950',
		value: 'plata_950'
	},
	{
		id: 3,
		name: 'Plata y Oro',
		value: 'plata_oro'
	},
	{
		id: 4,
		name: 'Acero Quirúrgico',
		value: 'acero_quirurgico'
	},
	{
		id: 5,
		name: 'Acero Dorado',
		value: 'acero_dorado'
	},
	{
		id: 6,
		name: 'Acero Blanco',
		value: 'acero_blanco'
	},
	{
		id: 7,
		name: 'Silicona',
		value: 'silicona'
	},
	{
		id: 8,
		name: 'Cuero',
		value: 'cuero'
	},
	{
		id: 9,
		name: 'Metal',
		value: 'metal'
	},
	{
		id: 10,
		name: 'Caucho',
		value: 'caucho'
	},
	{
		id: 11,
		name: 'Otro',
		value: ''
	}
]